// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9ee1fba4","453":"bd2a4233"}[chunkId] + ".chunk.js";
};